module.exports = __webpack_public_path__ + "img/5-5.cac77309.svg";